import React from "react";
import { Image as ImageIcon, ImageOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// Sprint UI-GLOBALE — preferenza utente già esistente (preferenze_vista_veicoli.mostra_miniatura),
// valida per tutte le liste con veicolo. Assente = foto mostrate.
export function useMostraFoto() {
  const { user, setUser } = useAuth();
  const mostra = user?.preferenze_vista_veicoli?.mostra_miniatura !== false;
  const imposta = async (val) => {
    const applica = (prefs) => setUser?.((u) => {
      if (!u) return u;
      const next = { ...u, preferenze_vista_veicoli: prefs };
      try { localStorage.setItem("dms_user", JSON.stringify(next)); } catch {}
      return next;
    });
    applica({ ...(user?.preferenze_vista_veicoli || {}), mostra_miniatura: val });
    try {
      const r = await api.patch("/users/me/preferenze-vista-veicoli", { mostra_miniatura: val });
      if (r.data?.preferenze_vista_veicoli) applica(r.data.preferenze_vista_veicoli);
    } catch { /* la scelta resta valida in questa sessione */ }
  };
  return [mostra, imposta];
}

export default function MostraFotoToggle({ mostra, onChange }) {
  return (
    <Button variant="outline" onClick={() => onChange(!mostra)} aria-pressed={mostra} data-testid="toggle-foto-btn">
      {mostra ? <ImageOff className="h-4 w-4 mr-1.5" /> : <ImageIcon className="h-4 w-4 mr-1.5" />}
      {mostra ? "Nascondi foto" : "Mostra foto"}
    </Button>
  );
}
